import ApiCMS from '@/axios/apiCMS'

export default {
  async getTooltips ({ commit }, type = 'Account') {
    return ApiCMS.get('/tooltips?populate=*&pagination[limit]=9999999', {
      params: {
        'filters[Type][$eq]': type
      }
    }).then(response => {
      commit('setTooltips', response.data.data ?? response.data)
    })
  }
}
